import { When } from "react-if";
import { UserDeskHub } from "_services/ws/user-desk-hub";
import { Table } from "_pages/service/queue/components/table/Table";
import { observer } from "@legendapp/state/react";
import { useCurrentAttendanceSession } from "_api/hooks/attendances";
import { AttendanceNotStarted } from "_pages/service/queue/components/AttendanceNotStarted";
import { $currentAttendanceId } from "_pages/service/queue/state";
import { useRelativeGo } from "_utils/url";
import { useEffect } from "react";
import { VStack } from "_ui/Box";
import { InputSuspense } from "_components/suspense/parts";
import TableSuspense from "_components/suspense/TableSuspense";
import { Card } from "react-bootstrap";


export const ClientListSuspense = () => (
    <Card className='w-100'>
        <Card.Body>
            <VStack g={2}>
                <InputSuspense />
                <TableSuspense columns={4} rows={5} />
            </VStack>
        </Card.Body>
    </Card>

)

const ClientsList = observer(() => {
    const go = useRelativeGo();
    const attendanceId = $currentAttendanceId.get();

    useEffect(() => {
        if (attendanceId) {
            go(attendanceId);
        }
    }, [attendanceId]);

    return (
        <Table />
    );
})

export default ClientsList;
